import { useCallback } from 'react'
import { PreOrderAttendeeItems } from '@ancon/wildcat-types'
import getCheckoutRequestItemFromCheckoutItem from '@ancon/wildcat-utils/checkout/getCheckoutRequestItemFromCheckoutItem'

import {
  isPreOrderCheckoutSelector,
  preOrderCheckoutAttendeesSelector,
} from '../../preOrder/store/preOrderSelectors'
import useAppDispatch from '../../../store/hooks/useAppDispatch'
import useAppStore from '../../../store/hooks/useAppStore'
import storedPaymentCorrelationId from '../../app/utils/storedPaymentCorrelationId'
import { updatePreOrderCheckout } from '../../preOrder/store/preOrderThunks'
import { updateCheckout } from '../store/checkoutThunks'
import { checkoutRetryAdyenPayment } from '../store/checkoutSlice'

function useCheckoutPriceChangePaymentRetry() {
  const dispatch = useAppDispatch()

  const store = useAppStore()

  const handlePaymentRetry = useCallback(async () => {
    const isPreOrderCheckout = isPreOrderCheckoutSelector(store.getState())
    const checkoutAttendees = preOrderCheckoutAttendeesSelector(
      store.getState(),
    )

    const skipPriceChangeErrorModal = true

    if (isPreOrderCheckout) {
      // For pre-order checkouts, trigger price changed updates for each attendee's items
      // to ensure the latest prices are reflected, before retrying payment
      const memberItems = checkoutAttendees.map<PreOrderAttendeeItems>(
        attendee => {
          const checkoutRequestItems = attendee.items.map(checkoutItem =>
            getCheckoutRequestItemFromCheckoutItem(
              checkoutItem,
              undefined,
              true,
            ),
          )

          return {
            attendeeId: attendee.id,
            items: checkoutRequestItems,
          }
        },
      )

      dispatch(
        updatePreOrderCheckout({
          skipPriceChangeErrorModal,
          memberItems,
        }),
      )
    } else {
      dispatch(updateCheckout({ skipPriceChangeErrorModal }))
    }

    // Refresh payment to allow retrying payment
    storedPaymentCorrelationId.refresh()
    dispatch(checkoutRetryAdyenPayment())
  }, [dispatch, store])

  return handlePaymentRetry
}

export default useCheckoutPriceChangePaymentRetry
